import { getReportServiceAPIHost, getUserRegion } from '../../../../utils';

const buildReportServiceQuery = (endpoint, { headers, data }) => {
    const clientName = getUserRegion();
    return {
        url: `${getReportServiceAPIHost()}${endpoint}?customer=${clientName}`,
        headers,
        data,
    };
};

export default buildReportServiceQuery;
